import { useContext } from "react";
import { urls } from "../../urls";
import { useSub } from "../subscription/useSub";
import type { AiResultHandoff } from "./aiResultHandoff";
import { AssistantPanelContext } from "./assistantPanelContext";

export const useAskFurther = (): ((handoff: AiResultHandoff) => void) | null => {
  const { hasAssistantAccess } = useSub();
  const panel = useContext(AssistantPanelContext);
  if (!panel?.openWithResult || !hasAssistantAccess || window.location.pathname === urls.app.assistant) return null;
  return panel.openWithResult;
};
